export const NavigateIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2884_3015)">
      <path d="M6.5 0.5L6.5005 2.031C8.3096 2.25682 9.74345 3.69081 9.96905 5.5H11.5V6.5L9.969 6.5005C9.7432 8.30945 8.30945 9.7432 6.5005 9.969L6.5 11.5H5.5V9.96905C3.69081 9.74345 2.25682 8.3096 2.031 6.5005L0.5 6.5V5.5H2.03095C2.25656 3.69064 3.69064 2.25656 5.5 2.03095V0.5H6.5ZM6 3C4.34314 3 3 4.34314 3 6C3 7.65685 4.34314 9 6 9C7.65685 9 9 7.65685 9 6C9 4.34314 7.65685 3 6 3ZM6 5C6.5523 5 7 5.4477 7 6C7 6.5523 6.5523 7 6 7C5.4477 7 5 6.5523 5 6C5 5.4477 5.4477 5 6 5Z" />
    </g>
    <defs>
      <clipPath id="clip0_2884_3015">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
